import { Button, Checkbox, Form, Input, Radio, Select } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EditTwoIcon from "../../../assets/icons/EditTwoIcon";
import KeyIcon from "../../../assets/icons/KeyIcon";
import ZikZakTik from "../../../assets/icons/ZikZakTik";
import placeHolderImage from "../../../assets/images/placeholder-image.png";
import useModal from "../../../hooks/useModal";
import AdminLayout from "../../../layouts/AdminLayout";
import { CommonStatus } from "../../../types";

import DoubleTik from "../../../assets/icons/DoubleTik";
import { capitalize } from "../../../utils/string";
import CustomSection from "../../ui/CustomSection";
import IconicTitle from "../../ui/IconicTitle";

import { IMAGE_URL } from "../../../constants/constants";
import { singUserDataAsync, updateUserDataAsync } from "../../../store/features/csoManager/user/userApi";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { AddZero } from "../../../utils/number";
import AddCso from "./AddCso";
import CreateNewRole from "./CreateNewRole";
import ResetPassword from "./ResetPassword";
import { getAllRoleListAsync } from "../../../store/features/csoManager/role/roleApi";
import { RoleData } from "../../../types/csoManager/role";

export default function ViewCsoDetails() {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const [userStatus, setStatus] = useState<"Active" | "Inactive" | "New" | undefined>(undefined);
  const { open, handleOpen, toggle } = useModal();
  const [checkedItems, setCheckedItems] = useState<any>([]);
  const [checkAll, setCheckAll] = useState(false);
  const { singleUserData } = useAppSelector((state) => state.user);
  const { roleList } = useAppSelector((state) => state.role);
  const [form] = Form.useForm();
  const [roleOptions, setRoleOptions] = useState<RoleData[]>([]);

  const handleCheckAll = (e: any) => {
    const checked = e.target.checked;
    setCheckAll(checked);
    setCheckedItems(
      navbarList.map((item) => ({
        module: item.name,
        checked,
        actions: item.actions.map(() => checked),
      }))
    );
  };

  const handleCheckboxChange = (
    moduleIdx: number,
    actionIdx: number,
    checked: boolean
  ) => {};

  // //dispatch
  // useEffect(() => {
  //   dispatch(
  //     singUserDataAsync({
  //       params: {
  //         id: id + "",
  //       },
  //     })
  //   );
  // }, [dispatch, id]);

  //dispatch
  useEffect(() => {
    dispatch(
      singUserDataAsync({
        params: {
          id: id + "",
        },
      })
    );
  }, [dispatch, id]);

  useEffect(() => {
    dispatch(
      getAllRoleListAsync({
        params: {
          skip: 0,
          limit: 100,
          status: "",
        },
      })
    );
  }, [dispatch]);

  useEffect(() => {
    const currentStatus = singleUserData?.userStatus;
    if (currentStatus) {
      const typedStatus = currentStatus as "Active" | "Inactive" | "New";
      setStatus(typedStatus);
      form.setFieldsValue({
        userStatus: typedStatus
      });
    } else {
      setStatus("Active");
      form.setFieldsValue({
        userStatus: "Active"
      });
    }
  }, [singleUserData?.userStatus, form]);

  const handleUpdateRole = () => {
    const values = form.getFieldsValue();
    const selectedRole = roleOptions[0]; // Get the first role of selected type
    
    if (!selectedRole || !id) return;

    // Only update role_id
    const updateData = {
      role_id: selectedRole._id
    };

    dispatch(
      updateUserDataAsync({
        data: updateData,
        others: {
          reRender: () => {
            dispatch(
              singUserDataAsync({
                params: { id: id + "" }
              })
            );
          },
          id: id
        },
      })
    );
  };

  useEffect(() => {
    if (singleUserData?.role_id) {
      form.setFieldsValue({
        role_type: singleUserData.role_id.role_type,
        role_name: singleUserData.role_id.role_name
      });
      
      // Set initial role options
      const rolesOfType = roleList.filter(
        role => role.role_type === singleUserData.role_id.role_type
      );
      setRoleOptions(rolesOfType);
    }
  }, [singleUserData, roleList, form]);

  return (
    <AdminLayout title="User Details" backLink="/admin/cso-manager/user-list">
      <Form
        className="custom-form space-y-[14px]"
        layout="vertical"
        size="large"
        form={form}
      >
        <CustomSection>
          <div className="w-full justify-start items-start gap-6 inline-flex">
            <img
              className="w-[100px] h-[100px] rounded-full"
              src={
                singleUserData?.profilePicture
                  ? IMAGE_URL + singleUserData?.profilePicture
                  : placeHolderImage
              }
              alt="..."
            />
            <div className="grow flex-col justify-start items-start gap-3 inline-flex">
              <div className=" w-full flex justify-between gap-4">
                <div className="grow flex-col justify-start items-start gap-4 inline-flex">
                  <div className="self-stretch flex-col justify-start items-start flex">
                    <div className="self-stretch text-[#212529] text-4xl font-bold font-['Inter'] leading-[50px]">
                      {singleUserData?.fullName || "N/A"}
                    </div>

                    <div className="self-stretch justify-start items-start gap-2 inline-flex">
                      <div className="text-[#3d4a5c] text-sm font-semibold font-['Encode Sans Condensed'] leading-snug">
                        Designation:
                      </div>
                      <div className="text-[#8797ae] text-sm font-semibold font-['Encode Sans Condensed'] leading-snug">
                        {singleUserData?.designation || "N/A"}
                      </div>
                    </div>
                  </div>

                  <div className="self-stretch">
                    <div className="text-[#3d4a5c] text-sm font-semibold font-['Encode Sans Condensed'] mb-2">
                      Short Bio:
                    </div>
                    <div className="text-body text-base leading-7">
                      {singleUserData?.shortBio || "N/A"}
                    </div>
                  </div>
                </div>

                <div className="flex-col justify-start items-end inline-flex">
                  <div className="text-[#4a71ff] text-5xl font-bold font-['Inter'] leading-[50px]">
                    {AddZero(singleUserData?.totalPublications)}
                  </div>
                  <div className="self-stretch text-right text-[#4a71ff] text-base font-medium font-['Inter']">
                    Articles
                  </div>
                </div>
              </div>
              <hr className="self-stretch h-[0px] border border-[#e9eff6] border-solid" />

              <div className="flex-col justify-start items-start gap-1.5 flex">
                <UserInformation
                  title="Regional Hub"
                  value={singleUserData?.regional_hub_id?.hubTitle}
                />
                <UserInformation title="Regional Address" value={singleUserData?.regional_hub_id?.address} />

                <UserInformation
                  title="Email Address"
                  value={singleUserData?.email}
                />
                <UserInformation
                  title="Contact"
                  value={singleUserData?.mobile}
                />

                <UserInformation
                  title="User Type"
                  value={singleUserData?.role_id?.role_type}
                />
              </div>

              <hr className="self-stretch h-[0px] border border-[#e9eff6] border-solid" />

              <div className="flex justify-between items-center w-full">
                <div className="flex items-center">
                  <p className="w-[120px] text-[#3d4a5c] text-sm font-semibold font-['Encode Sans Condensed'] leading-snug">
                    User Status:
                  </p>
                  <Form.Item name="userStatus" className="hide_margin">
                    <Radio.Group
                      className="custom-radio"
                      onChange={(e) => {
                        const newStatus = e.target.value;
                        setStatus(newStatus);
                        
                        // Update user status
                        if (!id) return;
                        
                        dispatch(
                          updateUserDataAsync({
                            data: {
                              userStatus: newStatus
                            },
                            others: {
                              reRender: () => {
                                dispatch(
                                  singUserDataAsync({
                                    params: { id: id + "" }
                                  })
                                );
                              },
                              id: id
                            },
                          })
                        );
                      }}
                      value={singleUserData?.userStatus || userStatus}
                      size="large"
                    >
                      {statusList?.map((el, idx) => (
                        <Radio
                          className="text-body text-base font-medium leading-7 mr-3.5"
                          value={el}
                          key={idx}
                        >
                          {el}
                        </Radio>
                      ))}
                    </Radio.Group>
                  </Form.Item>
                </div>

                <div className="justify-start items-center gap-x-3 inline-flex">
                  <Button
                    className="w-full text-primary bg-[#fff4f4] "
                    type="text"
                    size="large"
                    icon={<EditTwoIcon />}
                    onClick={() =>
                      handleOpen({
                        type: "EDIT",
                      })
                    }
                  >
                    Edit
                  </Button>

                  <Button
                    className="w-full text-[#4a71ff] bg-[#f2f4ff] "
                    type="text"
                    size="large"
                    icon={<KeyIcon />}
                    onClick={() =>
                      handleOpen({
                        type: "RESET_PASSWORD",
                        data: singleUserData
                      })
                    }
                  >
                    Reset Password
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </CustomSection>

        <CustomSection>
          <div className="flex justify-between items-center w-full">
            <IconicTitle
              icon={<ZikZakTik />}
              className="text-primary"
              title="User Role"
            />

            {/* <Button
              className="text-primary bg-[#fff4f4]"
              type="text"
              size="large"
              icon={<KeyIcon />}
              onClick={() =>
                handleOpen({
                  type: "ADD",
                })
              }
            >
              Create new role
            </Button> */}
          </div>

          <div className="grid grid-cols-3 gap-4 w-full mt-4">
            <Form.Item
              name="role_type"
              label="Select Role Type"
              rules={[
                {
                  required: true,
                  message: "Please select role",
                },
              ]}
            >
              <Select
                placeholder="Select Role Type"
                size="large"
                onChange={(value) => {
                  // Find roles matching selected type
                  const rolesOfType = roleList.filter(role => role.role_type === value);
                  if (rolesOfType.length > 0) {
                    form.setFieldsValue({ role_name: rolesOfType[0].role_name });
                    setRoleOptions(rolesOfType);
                  }
                }}
                options={Array.from(new Set(roleList.map(role => role.role_type))).map(type => ({
                  label: capitalize(type),
                  value: type
                }))}
              />
            </Form.Item>

            <Form.Item
              name="role_name"
              label="Role Name"
            >
              <Input 
                placeholder="Role name will appear here"
                size="large"
                disabled
                value={roleOptions[0]?.role_name || ''}
              />
            </Form.Item>

            <div className="flex items-end">
              <Button
                className="text-primary bg-[#fff4f4]"
                type="text"
                size="large"
                icon={<EditTwoIcon />}
                onClick={handleUpdateRole}
              >
                Update Role
              </Button>
            </div>
          </div>
        </CustomSection>
{/* 
        <CustomSection>
          <div className="flex items-center gap-x-2.5 mb-4">
            <IconicTitle
              icon={<ZikZakTik />}
              title="Permission Setting"
              className="text-primary"
            />

            <Checkbox checked={checkAll} onChange={handleCheckAll}>
              {" "}
              <span className="text-sm font-medium leading-6 -tracking-[0.2px] text-others-table-header select-none">
                All
              </span>
            </Checkbox>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full form_custom_checkbox table-auto border-collapse border border-others-border border-solid w-full ">
              <tbody>
                {navbarList.map((el, moduleIdx: number) => (
                  <tr key={el?._id}>
                    <td className="sticky left-0 z-10 bg-[#FFF5F4] px-4 py-2 border border-r-0 border-others-border border-solid">
                      <p className="text-sm font-medium leading-6 -tracking-[0.2px] text-others-table-header">
                        {el?.name}
                      </p>
                    </td>

                    {el?.actions.map((action: any, actionIdx: number) => (
                      <td
                        key={action?._id}
                        className="px-4 py-2 text-center border border-r-0 border-l-0 border-others-border border-solid "
                      >
                        <Checkbox
                          checked={
                            checkedItems[moduleIdx]?.actions[actionIdx] || false
                          }
                          onChange={(e) =>
                            handleCheckboxChange(
                              moduleIdx,
                              actionIdx,
                              e.target.checked
                            )
                          }
                        >
                          <span className="text-sm font-medium leading-6 -tracking-[0.2px] text-others-table-header select-none">
                            {capitalize(action?.name)}
                          </span>
                        </Checkbox>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CustomSection> */}
      </Form>

      {/* Product create and update form modal */}
      {open?.type === "RESET_PASSWORD" && (
        <ResetPassword open={open} handleClose={toggle} />
      )}

      {/* Product create and update form modal */}
      {open?.type === "EDIT" && <AddCso open={open} handleClose={toggle} />}

      {/* Product create and update form modal */}
      {open?.type === "ADD" && (
        <CreateNewRole open={open} handleClose={toggle} />
      )}

      {/* Product create and update form modal */}
      {/* {(open?.type === "ADD" || open?.type === "EDIT") && (
        <AddCso open={open} handleClose={toggle} />
      )} */}
    </AdminLayout>
  );
}

const statusList = ["Active", "Inactive", "New"];

function UserInformation({ title, value }: any) {
  return (
    <div className="self-stretch justify-start items-center gap-2 inline-flex">
      <div className="w-[150px] text-[#3d4a5c] text-sm font-semibold font-['Encode Sans Condensed'] leading-snug">
        {title}:
      </div>
      <div className="grow shrink basis-0 text-[#8797ae] text-sm font-semibold font-['Encode Sans Condensed'] leading-snug">
        {value || "N/A"}
      </div>
    </div>
  );
}

const RoleType = ["admin", "cso", "cso_admin"];

const navbarList = [
  {
    name: "Post Creating",
    _id: 1,
    actions: [
      {
        name: "Index",
      },
      {
        name: "Create",
      },
      {
        name: "Show",
      },
      {
        name: "Update",
      },
      {
        name: "Destroy",
      },
    ],
  },
  {
    name: "Events",

    actions: [
      {
        name: "Index",
      },
      {
        name: "Create",
      },
      {
        name: "Show",
      },
      {
        name: "Update",
      },
      {
        name: "Destroy",
      },
    ],
  },
  {
    name: "Message/Chat",

    actions: [
      {
        name: "Index",
      },
      {
        name: "Create",
      },
      {
        name: "Show",
      },
      {
        name: "Update",
      },
      {
        name: "Destroy",
      },
    ],
  },
  {
    name: "Community Forum",

    actions: [
      {
        name: "Index",
      },
      {
        name: "Create",
      },
      {
        name: "Show",
      },
      {
        name: "Update",
      },
      {
        name: "Destroy",
      },
    ],
  },
  {
    name: "Discussion Board",

    actions: [
      {
        name: "Index",
      },
      {
        name: "Create",
      },
      {
        name: "Show",
      },
      {
        name: "Update",
      },
      {
        name: "Destroy",
      },
    ],
  },
  {
    name: "Training Materials",

    actions: [
      {
        name: "Index",
      },
      {
        name: "Create",
      },
      {
        name: "Show",
      },
      {
        name: "Update",
      },
      {
        name: "Destroy",
      },
    ],
  },
  {
    name: "Directory (CSO List)",

    actions: [
      {
        name: "Index",
      },
      {
        name: "Create",
      },
      {
        name: "Show",
      },
      {
        name: "Update",
      },
      {
        name: "Destroy",
      },
    ],
  },
  {
    name: "Profile",

    actions: [
      {
        name: "Index",
      },
      {
        name: "Create",
      },
      {
        name: "Show",
      },
      {
        name: "Update",
      },
      {
        name: "Destroy",
      },
    ],
  },
  {
    name: "Regional Hub Admin",

    actions: [
      {
        name: "Index",
      },
      {
        name: "Create",
      },
      {
        name: "Show",
      },
      {
        name: "Update",
      },
      {
        name: "Destroy",
      },
    ],
  },

  {
    name: "Website CMS Manage",
    actions: [
      {
        name: "Index",
      },
      {
        name: "Create",
      },
      {
        name: "Show",
      },
      {
        name: "Update",
      },
      {
        name: "Destroy",
      },
    ],
  },
  {
    name: "Donation",
    actions: [
      {
        name: "Index",
      },
      {
        name: "Create",
      },
      {
        name: "Show",
      },
      {
        name: "Update",
      },
      {
        name: "Destroy",
      },
    ],
  },
];
